import { AfterContentChecked, AfterViewInit, Component, ElementRef, HostListener, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { registerables } from 'chart.js';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { Observable, map, of } from "rxjs";

import { GurdServiceService } from "src/app/Service/gurd-service.service";

import { MapService } from "src/app/Service/map.service";

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";


import { DataService } from "src/app/Service/data.service";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

declare let $: any;


@Component({

  selector: 'app-tanker-dashboard',

  templateUrl: './tanker-dashboard.component.html',

  styleUrls: ['./tanker-dashboard.component.css']

})

export class TankerDashboardComponent implements OnInit {

  currentValue: number = 0;

  maxCapacity: number = 0;

  ctx1: any;

  ctx2: any;

  ctx3: any;

  ctx4: any;

  ctx5: any;

  ctx6: any;

  ctx7: any;

  map1: any;

  map2: any;

  source: any;

  source2: any;

  vector: any;

  vector2: any;

  layers: any = [];

  layers2: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  tankerData: any = [];

  CHART_COLORS3: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  CHART_COLORS: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };

  constructor(

    private router: Router,

    private notifyService: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private otherService: OtherService,

    private mapService: MapService,

  ) {

    Chart.register(...registerables);

    Chart.register(zoomPlugin);

  }

  ngOnInit(): void {

    this.getChartData()

  }

  getChartData = async () => {

    var model = {

      iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)

    }

    this.otherService.Showspinner()

    await this.getChartData1(model)

    await this.getChartData2(model)

    await this.getChartData3(model)

    await this.getChartData4(model)

    await this.getChartData5(model)

    await this.getChartData6(model)

    await this.getChartData7(model)

    await this.getMapData(model)

    await this.getMapData2(model)

    this.otherService.nonespinner()

  }

  getChartData1 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_CapacityStatus`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    this.currentValue = resParse[0].CurrentValue;

    this.maxCapacity = resParse[0].Maximume;

    this.ctx1 = new Chart('myChart', {

      type: 'doughnut',

      plugins: [{

        afterDraw: (chart: any) => {

          var angle = Math.PI + (1 / resParse[0].Maximume * resParse[0].CurrentValue * Math.PI);
          var ctx = chart.ctx;
          var cw = chart.canvas.offsetWidth;
          var ch = chart.canvas.offsetHeight;
          var cx = cw / 2;
          var cy = ch - 6;

          ctx.translate(cx, cy);
          ctx.rotate(angle);
          ctx.beginPath();
          ctx.moveTo(0, -3);
          ctx.lineTo(ch - 20, 0);
          ctx.lineTo(0, 3);
          ctx.fillStyle = 'rgb(0, 0, 0)';
          ctx.fill();
          ctx.rotate(-angle);
          ctx.translate(-cx, -cy);
          ctx.beginPath();
          ctx.arc(cx, cy, 5, 0, Math.PI * 2);
          ctx.fill();
        }
      }] as any,
      data: {
        labels: [],
        datasets: [{
          data: [resParse[0].Maximume / 3, resParse[0].Maximume / 3, resParse[0].Maximume / 3],
          needleValue: 27,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 206, 86, 0.2)',
            'rgba(63, 191, 63, 0.2)'
          ]
        }] as any
      },
      options: {
        responsive: false,
        aspectRatio: 2,
        layout: {
          padding: {
            bottom: 3
          }

        },

        rotation: -90,
        cutout: '50%',
        circumference: 180,
        animation: {
          animateRotate: false,
          animateScale: true
        }
      }
    });

  }

  getChartData2 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_BaseMaterialType`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    let obj = resParse;

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    obj.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    var canvas = document.getElementById("myChart1") as any;

    var ctx = canvas.getContext("2d");

    const DATA_COUNT = 5;

    const data = {

      labels: label,

      datasets: [

        {
          data: datachart,

          backgroundColor: Object.values(this.CHART_COLORS3),
        },

      ],

    } as any;

    if (this.ctx2) this.ctx2.destroy();

    this.ctx2 = new Chart(ctx, {

      type: 'pie',

      data: data,

      options: {
        responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'top',

            labels: {

              color: "black",

            }

          },

          title: {

            display: false,

          },

        },

      },

    });

  }

  getChartData3 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_AvailableBaseTanker`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    let obj = resParse;

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    obj = resParse;

    label = [];

    datachart = [];

    obj.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    const ctx = document.getElementById('myChart2') as any;

    if (this.ctx3) this.ctx3.destroy();

    this.ctx3 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            data: datachart,

            backgroundColor: Object.values(this.CHART_COLORS),

            borderWidth: 1,

          },

        ],

      },

      options: {

        plugins: {

          legend: {

            position: 'center',

            labels: {

              color: "black",

            }

          },

          zoom: {

            zoom: {

              wheel: {

                enabled: true,

              },

              pinch: {

                enabled: true

              },

              mode: 'x',

            }

          },

          title: {

            display: false,

          },

        },

                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        scales: {

          x: {

            ticks: {

              color: 'black',

              font: {

                family: "bYekan",

                size: 12

              }

            }

          },

        }

      },

    });

  }

  getChartData4 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_BaseCapacity`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    let obj = resParse;

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    obj = resParse;

    label = [];

    datachart = [];

    obj.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    const ctx = document.getElementById('myChart3') as any;

    if (this.ctx4) this.ctx4.destroy();

    this.ctx4 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            data: datachart,

            backgroundColor: Object.values(this.CHART_COLORS),

            borderWidth: 1,

          },

        ],

      },

      options: {

                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {

          legend: {

            position: 'center',

            labels: {

              color: "black",

            }

          },

          zoom: {

            zoom: {

              wheel: {

                enabled: true,

              },

              pinch: {

                enabled: true

              },

              mode: 'x',

            }

          },

          title: {

            display: false,

          },

        },

        scales: {

          x: {

            ticks: {

              color: 'black',

              font: {

                family: "bYekan",

                size: 12

              }

            }

          },

        }

      },

    });

  }

  getChartData5 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_FeedingBaseGeoFence`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    let obj = resParse;

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    obj = resParse;

    label = [];

    datachart = [];

    obj.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    const ctx = document.getElementById('myChart4') as any;

    if (this.ctx5) this.ctx5.destroy();

    this.ctx5 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            data: datachart,

            backgroundColor: Object.values(this.CHART_COLORS),

            borderWidth: 1,

          },

        ],

      },

      options: {

                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'center',

            labels: {

              color: "black",

            }

          },

          zoom: {

            zoom: {

              wheel: {

                enabled: true,

              },

              pinch: {

                enabled: true

              },

              mode: 'x',

            }

          },

          title: {

            display: false,

          },

        },

        scales: {

          x: {

            ticks: {

              color: 'black',

              font: {

                family: "bYekan",

                size: 12

              }

            }

          },

        }

      },

    });

  }

  getChartData6 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_Feeding_Daily`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    let obj = resParse;

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    obj = resParse;

    label = [];

    datachart = [];

    obj.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    const ctx = document.getElementById('myChart5') as any;

    if (this.ctx6) this.ctx6.destroy();

    this.ctx6 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            data: datachart,

            backgroundColor: Object.values(this.CHART_COLORS),

            borderWidth: 1,

          },

        ],

      },

      options: {

                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'center',

            labels: {

              color: "black",

            }

          },

          zoom: {

            zoom: {

              wheel: {

                enabled: true,

              },

              pinch: {

                enabled: true

              },

              mode: 'x',

            }

          },

          title: {

            display: false,

          },

        },

        scales: {

          x: {

            ticks: {

              color: 'black',

              font: {

                family: "bYekan",

                size: 12

              }

            }

          },

        }

      },

    });

  }

  getChartData7 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_Discharge_Daily`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    let obj = resParse;

    let label: Array<any> = [];

    let datachart: Array<any> = [];

    obj = resParse;

    label = [];

    datachart = [];

    obj.forEach((element: any) => {

      label.push(element.X);

      datachart.push(element.Y);

    });

    const ctx = document.getElementById('myChart6') as any;

    if (this.ctx7) this.ctx7.destroy();

    this.ctx7 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            data: datachart,

            backgroundColor: Object.values(this.CHART_COLORS),

            borderWidth: 1,

          },

        ],

      },

      options: {

                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },

        plugins: {

          legend: {

            position: 'center',

            labels: {

              color: "black",

            }

          },

          zoom: {

            zoom: {

              wheel: {

                enabled: true,

              },

              pinch: {

                enabled: true

              },

              mode: 'x',

            }

          },

          title: {

            display: false,

          },

        },

        scales: {

          x: {

            ticks: {

              color: 'black',

              font: {

                family: "bYekan",

                size: 12

              }

            }

          },

        }

      },

    });

  }

  getMapData = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_GeoDischarge`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    setTimeout(() => {

      if (this.map1) this.map1.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }

      this.map1 = new Map({

        target: "map1",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers

      });

      // console.log(resParse)

      this.clustersLayer(resParse, model);

    }, 500);

  }

  clustersLayer = async (data: any, model: []) => {

    setTimeout(() => {

      this.map1.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(
          this.map1.getEventPixel(e.originalEvent),
          this.map1
        );

        if (el.featureLayer && el.featureLayer.feature.values_.features.length == 1) this.showDetail(el.featureLayer.feature.values_.features[0].values_.data, model)

        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.map1.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;


    let addFeatures = (nb: any) => {
      var ext = this.map1.getView().calculateExtent(this.map1.getSize());
      var features = [];

      for (var i = 0; i < data.length; ++i) {
        features[i] = new Feature({
          type: 'removable',
          geometry: new Point(this.mapService.transformCoordinates2([
            data[i].fLon,
            data[i].fLat])

          ),
          id_: data[i].iTanker_Discharge,
          data: {
            strDate: data[i].strDate,
            strSTime: data[i].strSTime.trim(),
            strETime: data[i].strETime.trim(),
            fDischargeValue: data[i].fDischargeValue.toLocaleString(),
            strFullName: data[i].strFullName,
            strVehicleNo: data[i].strVehicleNo,
            strMobile: data[i].strMobile,
            strMobileDomain_strComment: data[i].strMobileDomain_strComment,
            strGPSType_strComment: data[i].strGPSType_strComment,
            fCapacity: data[i].fCapacity.toLocaleString(),
          },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.map1.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.map1.addInteraction(selectCluster);


  }

  getMapData2 = async (model: any) => {

    const resp = await axios.post(`Tanker_Dashboard_MapCapacityStatus`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.notifyService.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.notifyService.showError('لطفا وارد سیستم شوید');

      this.otherService.removeLocalStorage();

      this.router.navigate(['login']);

      return;

    }

    setTimeout(() => {

      if (this.map2) this.map2.setTarget(null);

      this.source2 = new VectorSource({ wrapX: false });

      this.vector2 = new VectorLayer({

        source: this.source2,

      });

      if (this.bOfflineMap) {

        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers2.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)
      }

      this.map2 = new Map({

        target: "map2",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers2

      });

      resParse.forEach((point: any) => {

        let iconSrc;

        if (point.Color == 1) iconSrc = '../../assets/Img/redBus.png';

        else if (point.Color == 2) iconSrc = '../../assets/Img/orangeBus.png';

        else if (point.Color == 3) iconSrc = '../../assets/Img/blueBus.png';

        else iconSrc = '../../assets/Img/greenBus.png';

        const iconStyle = new Style({

          image: new Icon({

            src: iconSrc,

            size: [40, 38],

            anchor: [0.5, 1],

          }),

        });

        const marker = new Feature({ geometry: new Point(olProj.fromLonLat([point.dLongitude, point.dLatitude])) });

        marker.setStyle(iconStyle);

        const vectorSource = new VectorSource({ features: [marker] });

        const vectorLayer = new VectorLayer({ source: vectorSource });

        marker.set('tankerData', point)

        this.map2.addLayer(vectorLayer);



      });

      this.map2.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(

          this.map2.getEventPixel(e.originalEvent),

          this.map2

        );

        var data = el.featureLayer.feature.values_.tankerData;

        const strVehicleNo = data.strVehicleNo.split(' ');

        data.strVehicleNo = ' ایران ' + (strVehicleNo[4]) + '  |  ' + strVehicleNo[2] + ' ' + strVehicleNo[1] + ' ' + strVehicleNo[0];

        this.notifyService.showInfo(` پلاک : ${data.strVehicleNo}  `, `نام راننده : ${data.strFullName}`)

        // console.log(el.featureLayer.feature.values_.tankerData)

      });

    }, 500);


  }

  showDetail = async (data: string[] | number, model: any) => {

    this.tankerData = data;

    $('#detailModal').modal('show');

  }

  formatted_pelak(strVehicle: any) {

    return `ایران ${strVehicle.split(' ')[4]} | ${strVehicle.split(' ')[2]} ${strVehicle.split(' ')[1]} ${strVehicle.split(' ')[0]}`;

  }

  goBack() {

    this.router.navigateByUrl('')

  }


}
